import React from 'react'
import TradeList from './List'
import { Layout } from 'antd'
import Header from '../../Header'

const { Content } = Layout

const Trade = (props) => {
  const id = props.match.params.loyalty

  return (
    <Layout className='layout'>
      <Header item='loyalty' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <TradeList id={id} />
        </div>
      </Content>
    </Layout>
  )
}

export default Trade
